import { render, staticRenderFns } from "./TasksListView.vue?vue&type=template&id=5129a778&scoped=true"
import script from "./TasksListView.vue?vue&type=script&lang=js"
export * from "./TasksListView.vue?vue&type=script&lang=js"
import style0 from "./TasksListView.vue?vue&type=style&index=0&id=5129a778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5129a778",
  null
  
)

export default component.exports